import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  status: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: 6,
    marginBottom: 6,
    paddingTop: 8,
    paddingBottom: 8,
    boxSizing: 'border-box',
    borderTop: '1px solid #E8ECF2',
    borderBottom: '1px solid #E8ECF2',
    backgroundColor: '#FAFBFC',
  },
  connectorPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 5,
    maxWidth: '100%',
    padding: '5px 12px',
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    fontFamily: 'Poppins, sans-serif',
    letterSpacing: '0.03em',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    transition: 'background-color 0.15s ease, border-color 0.15s ease',
  },
  pillIcon: {
    fontSize: 14,
    width: 14,
    height: 14,
    flexShrink: 0,
  },
  pillText: {
    fontSize: 11,
    fontWeight: 600,
    fontFamily: 'Poppins, sans-serif',
    letterSpacing: '0.03em',
    lineHeight: 1.2,
    color: 'inherit',
  },
  pillConfirm: {
    backgroundColor: '#E8F4FA',
    color: '#0B5F7A',
    border: '1px solid #9FD4EA',
  },
  pillCancel: {
    backgroundColor: '#FDECEC',
    color: '#B42318',
    border: '1px solid #F5C4C0',
  },
  pillWaiting: {
    backgroundColor: '#F4F5F6',
    color: '#5F6368',
    border: '1px solid #DADCE0',
  },
}));
